import { useCustomAuth } from '@/contexts/CustomAuthContext';

/**
 * Hook de autenticação que encapsula o CustomAuthContext
 * Fornece acesso às funcionalidades de autenticação do usuário
 */
export function useAuth() {
  const { user, plan, token, isAuthenticated, isLoading, login, logout, refreshUser, hasPermission } = useCustomAuth();

  return {
    user,
    plan,
    token,
    isAuthenticated,
    isLoading,
    login,
    signOut: logout, // Alias para manter compatibilidade
    logout,
    refreshUser,
    hasPermission,
  };
}
